import { TokenKeys, User } from "etl/types"

export interface AuthState {
	loading: boolean
	isAuthenticated: boolean
	user: User | undefined
	awToken: string | undefined
	awRefreshToken: string | undefined
	username: string | undefined
	password: string | undefined
}

export const authReducerInit = (): AuthState => {
	try {
		const awAuthToken = localStorage.getItem(TokenKeys.AW_TOKEN) || ""
		const awAuthTokenRefresh = localStorage.getItem(TokenKeys.AW_REFRESH_TOKEN) || ""
		const user = localStorage.getItem("user") || ""

		return {
			loading: false,
			isAuthenticated: !!awAuthToken,
			user: JSON.parse(user),
			awToken: awAuthToken,
			awRefreshToken: awAuthTokenRefresh,
			username: localStorage.getItem("username") || "",
			password: localStorage.getItem("password") || "",
		}
	} catch {
		return {
			loading: false,
			isAuthenticated: false,
			user: undefined,
			awToken: undefined,
			awRefreshToken: undefined,
			username: undefined,
			password: undefined,
		}
	}
}